
<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <div class="navigation">
        <ul class="container-width">
          <li
            :class="currentId == item.id ? 'active' : ''"
            v-for="(item, index) in navigationData"
            :key="index"
            @click="changeNav(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/nav/two">{{ navcurrent }}</router-link> >
      <router-link to="/nav/two">
        <span
          v-for="(item, index) in navigationData"
          :key="index"
          v-if="currentId == item.id"
        >
          {{ item.name }}
        </span> </router-link
      >>
      {{ current.title }}
    </div>
    <div class="container-width">
      <ARTICLE :current="current"></ARTICLE>
    </div>
  </div>
</template>
<script>
import service from "../../service/index";
import BANNER from "../../components/banner/navone";
export default {
  name: "NAVONEARTICLE",
  data() {
    return {
      navigationData: [],
      leftNavList: [],
      navcurrent: 0,
      id: 0,
      current: {},
      currentId: 0,
      currentName: "",
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.id = this.$route.query.id;
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let leftNavList = [];
      service.getNavMenuList({}, (res) => {
        res.content.map((item) => {
          if (item.navId == 2 && item.views == "显示") {
            leftNavList.push({
              name: item.name,
              id: item.id,
              navName: item.navName,
            });
          }
        });
        this.navigationData = leftNavList;
        this.navcurrent = leftNavList[0].navName;
      });
      let parmes = {
        id: this.id,
      };
      service.getwzNavigationMenuInfo(parmes, (res) => {
        if (res.current) {
          res.current.releaseDate = res.current.releaseDate
            ? res.current.releaseDate.split(" ")[0]
            : "";
          this.current = { ...res.current };
          this.currentId = res.current.navMenuId;
        }
      });
    },

    changeNav(e) {
      this.$router.push({
        path: "/nav/two",
        query: {
          id: e.id,
          name: e.name,
        },
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style scoped lang="scss">
.navigation {
  height: 60px;
  width: 100%;
  position: absolute;
  left: 0px;
  bottom: 0px;
  background-color: rgba(0, 71, 157, 0.9);
}
.navigation ul {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  height: 60px;
}
.navigation ul li {
  padding: 0 20px;
  box-sizing: border-box;
  text-align: center;
  height: 60px;
  line-height: 60px;
  margin-right: 20px;
  color: #fff;
  cursor: pointer;
}
.navigation .active {
  background-color: #842331;
}
.navigation ul li:hover {
  background-color: #842331;
}
.navigation ul li a {
  color: #fff;
  font-size: 1.2rem;
}
</style>